import { Bug } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BugIcon = createLucideIcon(Bug);
